var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"kheopsicon-success",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.height,"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"none","d":"M0 0h24v24H0z"}}),_c('path',{attrs:{"d":"M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }